import { Injectable } from '@angular/core';
import { HttpServices } from '../../../../../shared/services/http-service.service';
import { SmallUnitRequest } from '../models/Small-Unit-Request.model';
import { SmallUnitadminDTO } from 'src/app/admin/e-services/small-units/shared/models/small-units-admin.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SmallUnitsServiceFE {

  constructor(private http: HttpServices, private _http: HttpClient) {

  }
  SubmitEntranceRequest(data: SmallUnitRequest) {
    return this.http.post('SmallUnits/SubmitEntranceRequest', data);
  }

  edit(SmallUnitRequest: SmallUnitRequest) {
    return this.http.post('SmallUnits/SubmitEditedEntranceRequest', SmallUnitRequest);
  }
  Update(SmallUnitRequest: SmallUnitRequest) {
    return this.http.post('SmallUnits/Update', SmallUnitRequest);
  }

  get(Id: string) {
    return this.http.get('SmallUnits/Get/' + Id);
  }
  getAll(CreatedBy: string) {
    return this.http.get('SmallUnits/GetAll?CreatedBy=' + CreatedBy);
  }

  SubmitTransitDate(data: SmallUnitadminDTO) {
    return this.http.post('SmallUnits/AgentSumitTransitDate', data);
  } 

  getAuditorsList(groupName: string) {
    return this.http.get('SPGroupUser/GetSPUsersByGroupName?groupName=' + groupName);
  }
}